export function progressTransform(progressEvent: any): number {
  const { loaded = 0, total = 1 } = progressEvent
  return Math.floor((loaded / total) * 100)
}
